/* ==========================================================================
   Vitroswell — interacciones
   Todo vanilla, sin librerias. Cada init comprueba si su elemento existe,
   asi el mismo archivo vale para todas las paginas.
   ========================================================================== */

(function () {
  'use strict';

  var menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // El usuario NO quiere que el contenido aparezca (fade-up) conforme se baja:
  // la pagina debe verse entera y cargada desde el principio. Por eso los
  // reveals de scroll quedan DESACTIVADOS -> puedeAnimar = false. Como el CSS
  // solo esconde bajo la clase .vs-anim y aqui nunca se anade, todo el contenido
  // (incluidas las barras de la seccion "prueba") se muestra al instante.
  // El parallax del hero y la marquesina NO son reveals de carga, se conservan.
  var puedeAnimar = false;

  // (Antes: if (puedeAnimar) document.documentElement.classList.add('vs-anim'))

  // Red de seguridad: si por lo que sea el observer no llega a disparar, se
  // desiste de animar y se muestra todo. Mas vale sin animacion que en blanco.
  function rendirse() {
    document.documentElement.classList.remove('vs-anim');
  }

  /* --- Reveals de scroll (un unico observer compartido) ------------------- */

  function initReveals() {
    var elementos = document.querySelectorAll('.vs-reveal, .vs-cortina');
    if (!elementos.length || !puedeAnimar) return;

    var observer = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        entrada.target.classList.add('vs-visible');
        observer.unobserve(entrada.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    elementos.forEach(function (el) { observer.observe(el); });

    // A los 2 s, lo que este dentro de la pantalla ya deberia haberse revelado.
    // Si no, el observer no funciona en este navegador: fuera animaciones.
    setTimeout(function () {
      var enPantallaYOculto = [].slice.call(elementos).some(function (el) {
        if (el.classList.contains('vs-visible')) return false;
        var c = el.getBoundingClientRect();
        return c.top < window.innerHeight * 0.8 && c.bottom > 0;
      });
      if (enPantallaYOculto) rendirse();
    }, 2000);
  }

  /* --- Stagger: retrasa cada hijo de un grupo ----------------------------- */

  function initStagger() {
    document.querySelectorAll('[data-vs-stagger]').forEach(function (grupo) {
      var paso = parseInt(grupo.getAttribute('data-vs-stagger'), 10) || 90;
      var hijos = grupo.querySelectorAll('.vs-reveal, .vs-cortina');
      hijos.forEach(function (hijo, i) {
        hijo.style.setProperty('--vs-delay', (i * paso) + 'ms');
      });
    });
  }

  /* --- Parallax del hero (solo transform, via rAF) ------------------------ */

  function initParallax() {
    var capas = document.querySelectorAll('[data-vs-parallax]');
    if (!capas.length || menosMovimiento) return;
    if (window.matchMedia('(max-width: 990px)').matches) return;

    var pendiente = false;

    function pintar() {
      pendiente = false;
      capas.forEach(function (capa) {
        var intensidad = parseFloat(capa.getAttribute('data-vs-parallax')) || 0.14;
        var caja = capa.parentElement.getBoundingClientRect();
        if (caja.bottom < 0 || caja.top > window.innerHeight) return;
        var avance = (caja.top / window.innerHeight) * -1;
        capa.style.transform = 'translate3d(0,' + (avance * intensidad * 100).toFixed(2) + 'px,0)';
      });
    }

    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(pintar);
    }, { passive: true });

    pintar();
  }

  /* --- Cifras que cuentan al entrar en pantalla --------------------------- */

  function initContadores() {
    var cifras = document.querySelectorAll('[data-vs-contador]');
    if (!cifras.length) return;

    // La pagina va "ya cargada": las cifras muestran su valor final de una,
    // sin contar al entrar en pantalla (antes solo se hacia con reduced-motion).
    if (!puedeAnimar || menosMovimiento || !('IntersectionObserver' in window)) {
      cifras.forEach(function (el) { el.textContent = el.getAttribute('data-vs-contador'); });
      return;
    }

    var observer = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        contar(entrada.target);
        observer.unobserve(entrada.target);
      });
    }, { threshold: 0.5 });

    cifras.forEach(function (el) { observer.observe(el); });

    function contar(el) {
      var destino = el.getAttribute('data-vs-contador');
      // Soporta rangos tipo "4-8": cuenta el ultimo numero y conserva el formato
      var numeros = destino.match(/\d+/g);
      if (!numeros) { el.textContent = destino; return; }
      var fin = parseInt(numeros[numeros.length - 1], 10);
      var duracion = 1400;
      var inicio = null;

      function paso(ahora) {
        if (inicio === null) inicio = ahora;
        var t = Math.min((ahora - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - t, 3); // easeOutCubic
        var valor = Math.round(fin * suave);
        var i = 0;
        el.textContent = destino.replace(/\d+/g, function (n) {
          i++;
          return i === numeros.length ? valor : Math.round(parseInt(n, 10) * suave);
        });
        if (t < 1) window.requestAnimationFrame(paso);
      }
      window.requestAnimationFrame(paso);
    }
  }

  /* --- Marquesinas: duplica el grupo para que el bucle no tenga costura --- */

  function initMarquesinas() {
    document.querySelectorAll('[data-vs-marquesina]').forEach(function (pista) {
      var grupo = pista.querySelector('.vs-marq__grupo, .vs-res__grupo');
      // children.length > 1 significa que ya se duplico: no duplicar otra vez
      if (!grupo || pista.children.length > 1) return;
      var copia = grupo.cloneNode(true);
      copia.setAttribute('aria-hidden', 'true');
      pista.appendChild(copia);
    });
  }

  /* --- FAQ ---------------------------------------------------------------- */

  function initFaq() {
    var items = document.querySelectorAll('.vs-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('.vs-faq__btn');
      // El editor recarga secciones y vuelve a llamar a arrancar(): sin esta
      // marca el clic se engancharia dos veces y se anularia a si mismo.
      if (!btn || item.dataset.vsListo === '1') return;
      item.dataset.vsListo = '1';

      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('vs-abierto');
        // Acordeon: solo uno abierto a la vez dentro de la misma lista
        var lista = item.closest('.vs-faq__lista');
        if (lista) {
          lista.querySelectorAll('.vs-faq__item.vs-abierto').forEach(function (otro) {
            if (otro === item) return;
            otro.classList.remove('vs-abierto');
            var b = otro.querySelector('.vs-faq__btn');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('vs-abierto', !abierto);
        btn.setAttribute('aria-expanded', String(!abierto));
      });
    });
  }

  /* --- Comparador antes / despues ----------------------------------------- */

  function initComparadores() {
    document.querySelectorAll('[data-vs-comparador]').forEach(function (marco) {
      if (marco.dataset.vsListo === '1') return;
      marco.dataset.vsListo = '1';

      var rango = marco.querySelector('[data-vs-comp-rango]');
      var pos = rango ? parseFloat(rango.value) : 50;

      function pintar() {
        marco.style.setProperty('--vs-comp-x', pos + '%');
        if (rango && parseFloat(rango.value) !== pos) rango.value = pos;
      }

      /* El input range nativo NO sirve para arrastrar bien: el navegador
         reserva medio tirador en cada extremo, asi que el asa se desfasa del
         dedo cerca de los bordes. Calculamos la posicion del puntero a mano.
         El range se queda solo para teclado (accesibilidad). */
      function desdePuntero(e) {
        var r = marco.getBoundingClientRect();
        if (!r.width) return;
        var x = ((e.clientX - r.left) / r.width) * 100;
        pos = x < 0 ? 0 : (x > 100 ? 100 : x);
        pintar();
      }

      var arrastrando = false;

      marco.addEventListener('pointerdown', function (e) {
        if (e.button && e.button !== 0) return;
        arrastrando = true;
        try { marco.setPointerCapture(e.pointerId); } catch (err) {}
        marco.classList.add('vs-comp--arrastrando');
        desdePuntero(e);
      });

      marco.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        e.preventDefault();
        desdePuntero(e);
      });

      function soltar(e) {
        if (!arrastrando) return;
        arrastrando = false;
        marco.classList.remove('vs-comp--arrastrando');
        try { marco.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      marco.addEventListener('pointerup', soltar);
      marco.addEventListener('pointercancel', soltar);
      marco.addEventListener('lostpointercapture', soltar);

      if (rango) {
        rango.addEventListener('input', function () {
          pos = parseFloat(rango.value);
          pintar();
        });
      }

      pintar();
    });
  }

  /* --- Galeria del producto ----------------------------------------------- */

  function initGaleria() {
    var galeria = document.querySelector('[data-vs-galeria]');
    if (!galeria) return;

    var marco = galeria.querySelector('.vs-prod__principal');
    var pista = galeria.querySelector('[data-vs-galeria-pista]');
    var slides = pista ? Array.prototype.slice.call(pista.querySelectorAll('.vs-prod__slide')) : [];
    var minis = Array.prototype.slice.call(galeria.querySelectorAll('[data-vs-galeria-mini]'));
    var puntos = Array.prototype.slice.call(galeria.querySelectorAll('[data-vs-galeria-punto]'));
    if (!marco || !pista || galeria.dataset.vsListo === '1') return;
    galeria.dataset.vsListo = '1';
    if (slides.length < 2) return; // una sola foto: nada que deslizar ni marcar

    var total = slides.length;
    var activa = 0;
    var arrastreX = 0;
    minis.forEach(function (m, i) { if (m.classList.contains('vs-activa')) activa = i; });

    // Coloca la pista en la foto `activa`, sumando el arrastre en curso (px)
    // si lo hay. calc() mezcla el % (responsive) con el px del dedo sin mas.
    function situar(conTransicion) {
      pista.style.transition = conTransicion ? '' : 'none';
      pista.style.transform = 'translate3d(calc(' + (activa * -100) + '% + ' + arrastreX + 'px), 0, 0)';
    }

    function marcarActiva() {
      minis.forEach(function (m, i) { m.classList.toggle('vs-activa', i === activa); });
      puntos.forEach(function (p, i) {
        p.classList.toggle('vs-activo', i === activa);
        p.setAttribute('aria-current', i === activa ? 'true' : 'false');
      });
    }

    function irA(indice) {
      if (indice < 0) indice = 0;
      if (indice > total - 1) indice = total - 1;
      activa = indice;
      arrastreX = 0;
      situar(true);
      marcarActiva();
    }

    minis.forEach(function (m, i) { m.addEventListener('click', function () { irA(i); }); });
    puntos.forEach(function (p, i) { p.addEventListener('click', function () { irA(i); }); });

    /* Arrastrar con el dedo (o el raton) para pasar de foto. Con Pointer
       Events un unico camino sirve para tactil, raton y lapiz: el marco ya
       trae touch-action:pan-y desde el CSS, asi que el scroll vertical de la
       pagina sigue funcionando y solo se intercepta el gesto cuando queda
       claro que es horizontal. */
    if (window.PointerEvent) {
      var activo = false, inicioX = 0, inicioY = 0, modo = null, idPuntero = null;

      marco.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        activo = true;
        modo = null;
        idPuntero = e.pointerId;
        inicioX = e.clientX;
        inicioY = e.clientY;
      });

      marco.addEventListener('pointermove', function (e) {
        if (!activo || e.pointerId !== idPuntero) return;
        var dx = e.clientX - inicioX;
        var dy = e.clientY - inicioY;

        if (modo === null) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          modo = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical';
          if (modo === 'horizontal') {
            marco.classList.add('vs-prod__principal--arrastrando');
            try { marco.setPointerCapture(idPuntero); } catch (err) {}
          }
        }
        if (modo !== 'horizontal') return;

        e.preventDefault();
        // Resistencia si se arrastra hacia un lado sin foto (primera/ultima)
        if ((activa === 0 && dx > 0) || (activa === total - 1 && dx < 0)) dx *= 0.35;
        arrastreX = dx;
        situar(false);
      });

      function soltar(e) {
        if (!activo || (e && e.pointerId !== idPuntero)) return;
        activo = false;
        if (modo === 'horizontal') {
          var umbral = marco.clientWidth * 0.18;
          var destino = activa;
          if (arrastreX <= -umbral) destino = activa + 1;
          else if (arrastreX >= umbral) destino = activa - 1;
          marco.classList.remove('vs-prod__principal--arrastrando');
          try { marco.releasePointerCapture(idPuntero); } catch (err) {}
          irA(destino);
        }
        modo = null;
      }

      marco.addEventListener('pointerup', soltar);
      marco.addEventListener('pointercancel', soltar);
    }
  }

  /* --- Selector de variantes ---------------------------------------------- */

  function initVariantes() {
    var raiz = document.querySelector('[data-vs-variantes]');
    if (!raiz || raiz.dataset.vsListo === '1') return;
    raiz.dataset.vsListo = '1';

    var datos = raiz.querySelector('[data-vs-variantes-json]');
    var inputId = raiz.querySelector('[data-vs-variante-id]');
    var boton = raiz.querySelector('[data-vs-boton]');
    var precio = raiz.querySelector('[data-vs-precio]');
    var comparado = raiz.querySelector('[data-vs-comparado]');
    var estado = raiz.querySelector('[data-vs-stock]');
    // Campo oculto con las unidades del pack (properties[Incluye]). La variante
    // entra al carrito con cantidad 1, asi que sin esto el carrito diria "1"
    // aunque la clienta se lleve 2 o 4 botes.
    var articulos = raiz.querySelector('[data-vs-articulos]');
    // Campo oculto con el regalo del pack. Se desactiva si el pack no trae
    // regalo, para que no llegue al carrito una linea vacia.
    var regalo = raiz.querySelector('[data-vs-regalo]');
    // Suscripcion: bloque de modo de compra y campo oculto del plan.
    var modo = raiz.querySelector('[data-vs-modo]');
    var inputPlan = raiz.querySelector('[data-vs-plan]');
    // Modo marcado al entrar: lo decide el ajuste de la seccion (data-inicial).
    var modoElegido = (modo && modo.getAttribute('data-inicial') === 'suscripcion') ? 'suscripcion' : 'unica';
    // Aviso bajo el boton con la frecuencia y el precio de la suscripcion.
    var subInfo = raiz.querySelector('[data-vs-sub-info]');
    // Piezas reales que se mandan al carrito (2 o 4). El precio de la variante
    // es por unidad, asi que la cantidad NO cambia el total del pack.
    var inputCantidad = raiz.querySelector('[data-vs-cantidad]');
    if (!datos || !inputId) return;

    var variantes;
    try {
      variantes = JSON.parse(datos.textContent);
    } catch (e) {
      return;
    }
    if (!variantes || !variantes.length) return;

    var textoAgotado = raiz.getAttribute('data-texto-agotado') || 'Sold out';
    var textoComprar = boton ? boton.textContent.trim() : '';

    if (modo) {
      modo.querySelectorAll('[data-vs-modo-op]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          modoElegido = btn.getAttribute('data-vs-modo-op');
          modo.querySelectorAll('[data-vs-modo-op]').forEach(function (b) {
            b.classList.toggle('vs-activo', b === btn);
          });
          actualizar();
        });
      });
    }

    raiz.querySelectorAll('[data-vs-opcion]').forEach(function (grupo) {
      grupo.querySelectorAll('.vs-prod__valor').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('.vs-prod__valor').forEach(function (b) {
            b.classList.remove('vs-activo');
          });
          btn.classList.add('vs-activo');
          actualizar();
        });
      });
    });

    // Estado inicial: sin esto el selector de suscripcion no aparece
    // hasta que la clienta toca un pack.
    actualizar();

    function seleccion() {
      var valores = [];
      raiz.querySelectorAll('[data-vs-opcion]').forEach(function (grupo) {
        var activo = grupo.querySelector('.vs-prod__valor.vs-activo');
        valores.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return valores;
    }

    function actualizar() {
      var elegidos = seleccion();
      var variante = variantes.find(function (v) {
        return elegidos.every(function (val, i) { return v.options[i] === val; });
      });

      if (!variante) return;

      inputId.value = variante.id;

      // Se copia el "data-articulos" del pack elegido al campo oculto, para que
      // el carrito muestre cuantos botes lleva ese pack.
      if (articulos) {
        var packActivo = raiz.querySelector('.vs-prod__pack.vs-activo');
        articulos.value = packActivo ? (packActivo.getAttribute('data-articulos') || '') : '';
      }

      // La cantidad viene del JSON de variantes, que ya la trae calculada desde
      // el bloque del pack. Si faltara, se manda 1 para no cobrar de menos.
      if (inputCantidad) {
        var n = parseInt(variante.cantidad, 10);
        inputCantidad.value = (n > 0 ? n : 1);
      }

      // Suscripcion: se usa el primer plan de la variante. Si el pack elegido
      // no tiene plan, ese pack se vende en pago unico, pero se recuerda lo que
      // eligio la clienta para cuando cambie a un pack que si lo tenga.
      var plan = null;
      if (modo) {
        var planes = variante.planes || [];
        plan = planes.length ? planes[0] : null;
        var hayPlanes = variantes.some(function (v) { return v.planes && v.planes.length; });
        modo.hidden = !hayPlanes;
        var elAhorro = modo.querySelector('[data-vs-modo-ahorro]');
        if (elAhorro) elAhorro.textContent = (plan && plan.ahorro) ? plan.ahorro + '%' : '';
        // Si el pack elegido no tiene plan, se marca Pago unico y la opcion de
        // suscripcion queda apagada: que nadie crea que se suscribe sin estarlo.
        var modoVisible = plan ? modoElegido : 'unica';
        modo.querySelectorAll('[data-vs-modo-op]').forEach(function (b) {
          var op = b.getAttribute('data-vs-modo-op');
          b.classList.toggle('vs-activo', op === modoVisible);
          if (op === 'suscripcion') {
            b.classList.toggle('vs-prod__modo2-op--no', !plan);
            b.setAttribute('aria-disabled', plan ? 'false' : 'true');
          }
        });
      }
      var enSub = !!plan && modoElegido === 'suscripcion';

      // Cada tarjeta muestra el precio del modo elegido: en suscripcion, el del
      // plan con el de pago unico tachado.
      var subActivo = modoElegido === 'suscripcion';
      raiz.querySelectorAll('.vs-prod__pack').forEach(function (card) {
        var tieneSub = card.hasAttribute('data-precio-sub');
        var usarSub = subActivo && tieneSub;
        var b = card.querySelector('[data-vs-pack-precio]');
        var d = card.querySelector('[data-vs-pack-antes]');
        var p = card.getAttribute(usarSub ? 'data-precio-sub' : 'data-precio-unica');
        var a = card.getAttribute(usarSub ? 'data-antes-sub' : 'data-antes-unica');
        if (b && p) b.textContent = p;
        if (d) { d.textContent = a || ''; d.hidden = !a; }
        // Regalos que solo van con suscripcion (la ampolleta del pack de 3 meses)
        card.querySelectorAll('[data-vs-solo-sub]').forEach(function (el) { el.hidden = !usarSub; });
      });

      // Regalo que viaja al pedido: el del pack, mas el de suscripcion si toca.
      if (regalo) {
        var packRegalo = raiz.querySelector('.vs-prod__pack.vs-activo');
        var textoRegalo = packRegalo ? (packRegalo.getAttribute('data-regalo') || '') : '';
        var extraSub = packRegalo ? (packRegalo.getAttribute('data-regalo-sub') || '') : '';
        if (enSub && extraSub) textoRegalo = textoRegalo ? textoRegalo + ' + ' + extraSub : extraSub;
        regalo.value = textoRegalo;
        regalo.disabled = !textoRegalo;
      }

      if (inputPlan) {
        inputPlan.value = enSub ? plan.id : '';
        inputPlan.disabled = !enSub;
      }

      // Aviso bajo el boton: frecuencia sacada del nombre del plan de Shopify
      // ("Entregar cada 2 meses, 15 % de descuento" -> "2 meses").
      if (subInfo) {
        if (enSub) {
          var nombre = (plan.nombre || '').split(',')[0];
          var m = nombre.match(/cada\s+(.+)$/i);
          var frecuencia = m ? m[1].trim() : nombre;
          var plantilla = subInfo.getAttribute('data-plantilla') || '';
          subInfo.textContent = plantilla.replace('[frecuencia]', frecuencia).replace('[precio]', plan.price);
          subInfo.hidden = false;
        } else {
          subInfo.hidden = true;
        }
      }

      if (precio) precio.innerHTML = enSub ? plan.price : variante.price;
      if (comparado) {
        // En suscripcion se tacha el antes del pack o, si no tiene, su precio normal.
        var tachado = enSub ? (variante.compare_at_price || variante.price) : variante.compare_at_price;
        comparado.innerHTML = tachado || '';
        comparado.style.display = tachado ? '' : 'none';
      }
      if (boton) {
        boton.disabled = !variante.available;
        boton.textContent = variante.available ? textoComprar : textoAgotado;
      }
      if (estado) {
        estado.classList.toggle('vs-prod__punto--no', !variante.available);
      }
    }
  }

  /* --- Carrusel deslizable (reseñas) --------------------------------------
     El deslizamiento con el dedo es scroll nativo + scroll-snap (CSS), asi que
     funciona aunque este JS falle. Esto solo añade las flechas del raton. */

  function initCarruseles() {
    document.querySelectorAll('[data-vs-carrusel]').forEach(function (raiz) {
      if (raiz.dataset.vsListo === '1') return;
      raiz.dataset.vsListo = '1';

      var pista = raiz.querySelector('[data-vs-carrusel-pista]');
      var ant = raiz.querySelector('[data-vs-carrusel-ant]');
      var sig = raiz.querySelector('[data-vs-carrusel-sig]');
      if (!pista) return;

      // Las tarjetas son los hijos directos de la pista, sea cual sea su clase.
      // Antes se buscaba '.vs-res__card' a fuego, lo que dejaba fuera cualquier
      // carrusel nuevo (por ejemplo el de resenas en foto, .vs-resf__card).
      var tarjetas = Array.prototype.slice.call(pista.children);

      function paso() {
        var tarjeta = tarjetas[0];
        if (!tarjeta) return Math.round(pista.clientWidth * 0.8);
        var estilo = window.getComputedStyle(pista);
        var hueco = parseFloat(estilo.columnGap || estilo.gap) || 0;
        return Math.round(tarjeta.getBoundingClientRect().width + hueco);
      }

      var puntos = Array.prototype.slice.call(raiz.parentNode.querySelectorAll('[data-vs-carrusel-punto]'));

      // Indice de la tarjeta mas cercana al borde izquierdo visible
      function indiceActual() {
        var ref = pista.scrollLeft;
        var mejor = 0, dist = Infinity;
        tarjetas.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft - pista.offsetLeft - ref);
          if (d < dist) { dist = d; mejor = i; }
        });
        return mejor;
      }

      function actualizar() {
        var tope = pista.scrollWidth - pista.clientWidth - 2;
        if (ant) ant.disabled = pista.scrollLeft <= 2;
        if (sig) sig.disabled = pista.scrollLeft >= tope;

        if (puntos.length) {
          var i = indiceActual();
          puntos.forEach(function (p, n) { p.classList.toggle('vs-activo', n === i); });
        }
      }

      /* Ir a una posicion con red de seguridad: si el scroll suave no responde
         (hay navegadores donde no se ejecuta), se fuerza directo a los 450 ms.
         Sin esto, los botones parecerian rotos en esos navegadores. */
      function irA(destino) {
        destino = Math.max(0, Math.round(destino));
        if (menosMovimiento) { pista.scrollLeft = destino; actualizar(); return; }
        var antes = pista.scrollLeft;
        try {
          pista.scrollTo({ left: destino, behavior: 'smooth' });
        } catch (e) {
          pista.scrollLeft = destino;
          actualizar();
          return;
        }
        /* No basta con esperar al evento 'scroll': hay navegadores donde no se
           dispara tras un desplazamiento programado, y entonces los puntos y el
           estado de las flechas se quedaban congelados (con la flecha de atras
           desactivada, que ademas impedia volver). Por eso se refresca a mano. */
        setTimeout(function () {
          if (Math.abs(pista.scrollLeft - antes) < 2) pista.scrollLeft = destino;
          actualizar();
        }, 450);
        setTimeout(actualizar, 750);
      }

      puntos.forEach(function (p, i) {
        p.addEventListener('click', function () {
          var c = tarjetas[i];
          if (c) irA(c.offsetLeft - pista.offsetLeft);
        });
      });

      if (ant) ant.addEventListener('click', function () { irA(pista.scrollLeft - paso()); });
      if (sig) sig.addEventListener('click', function () { irA(pista.scrollLeft + paso()); });

      pista.addEventListener('scroll', actualizar, { passive: true });
      window.addEventListener('resize', actualizar);
      actualizar();
    });
  }

  /* --- Barra de compra fija (pagina de producto) ---------------------------
     Aparece cuando el boton de comprar de verdad ya ha quedado por encima de
     la pantalla, y se aparta al llegar al pie para no taparlo.

     Dos decisiones importantes:

     1. NO usa IntersectionObserver, sino el evento scroll. El observer no
        dispara en algunos entornos (ya paso con los reveals) y ahi la barra
        no llegaria a salir nunca. Con scroll + rAF funciona en todas partes
        y ademas se puede comprobar de verdad al verificar.

     2. El boton NO envia el formulario por su cuenta: pulsa el boton real.
        Asi el pack que se compra es SIEMPRE el que esta elegido arriba (una
        sola fuente de verdad) y UpCart intercepta igual que en un click
        normal. Si algun dia se cambia el boton real, esto sigue valiendo. */

  function initStickyCompra() {
    var barra = document.querySelector('[data-vs-sticky]');
    if (!barra || barra.dataset.vsListo === '1') return;

    var raiz = document.querySelector('[data-vs-variantes]');
    var formReal = raiz && raiz.querySelector('.vs-prod__form');
    var botonReal = raiz && raiz.querySelector('[data-vs-boton]');
    if (!formReal || !botonReal) return;

    barra.dataset.vsListo = '1';

    var btn = barra.querySelector('[data-vs-sticky-boton]');
    var precio = barra.querySelector('[data-vs-sticky-precio]');
    var comparado = barra.querySelector('[data-vs-sticky-comparado]');
    var pack = barra.querySelector('[data-vs-sticky-pack]');

    var precioReal = raiz.querySelector('[data-vs-precio]');
    var comparadoReal = raiz.querySelector('[data-vs-comparado]');
    var pie = document.querySelector('.vs-foot') || document.querySelector('footer');

    if (btn) {
      btn.addEventListener('click', function () {
        if (botonReal.disabled) return;
        botonReal.click();
      });
    }

    // Copia lo que initVariantes acaba de escribir arriba. No duplicamos la
    // logica de variantes: solo reflejamos el resultado.
    function espejo() {
      if (precio && precioReal) precio.innerHTML = precioReal.innerHTML;

      if (comparado && comparadoReal) {
        comparado.innerHTML = comparadoReal.innerHTML;
        var sinTachado = comparadoReal.style.display === 'none' ||
                         !comparadoReal.innerHTML.replace(/\s/g, '');
        comparado.style.display = sinTachado ? 'none' : '';
      }

      if (pack) {
        var activo = raiz.querySelector('[data-vs-opcion] .vs-prod__valor.vs-activo');
        if (activo) {
          pack.textContent = activo.getAttribute('data-valor') || activo.textContent.replace(/\s+/g, ' ').trim();
        }
      }

      // El texto del boton NO se copia: el de la barra puede ser mas corto a
      // proposito. Solo se copia si esta disponible o no.
      if (btn) btn.disabled = botonReal.disabled;
    }

    if (window.MutationObserver) {
      new MutationObserver(espejo).observe(raiz, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'style', 'class']
      });
    }
    // Respaldo por si no hay MutationObserver: tras cualquier click arriba.
    raiz.addEventListener('click', function () { window.setTimeout(espejo, 0); });

    var pedido = false;
    function revisar() {
      if (pedido) return;
      pedido = true;
      window.requestAnimationFrame(function () {
        pedido = false;
        var pasado = formReal.getBoundingClientRect().bottom < 0;
        var pieALaVista = pie ? pie.getBoundingClientRect().top < window.innerHeight : false;
        barra.classList.toggle('vs-sticky--on', pasado && !pieALaVista);
      });
    }

    window.addEventListener('scroll', revisar, { passive: true });
    window.addEventListener('resize', revisar, { passive: true });
    espejo();
    revisar();
  }

  /* --- Video con portada -------------------------------------------------- */
  // No cargamos YouTube/Vimeo hasta que alguien pulse: evita traer el JS de un
  // tercero (y sus cookies) en cada visita solo por tener un video en la pagina.

  function initVideoLazy() {
    document.querySelectorAll('[data-vs-video-lazy]').forEach(function (boton) {
      if (boton.dataset.vsListo === '1') return;
      boton.dataset.vsListo = '1';

      boton.addEventListener('click', function () {
        var tipo = boton.getAttribute('data-vs-video-src');
        var id = boton.getAttribute('data-vs-video-id');
        if (!id) return;

        var src = tipo === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
          : 'https://www.youtube.com/embed/' + id + '?rel=0&autoplay=1';

        var marco = document.createElement('iframe');
        marco.setAttribute('src', src);
        marco.setAttribute('title', boton.getAttribute('aria-label') || 'Video');
        marco.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        marco.setAttribute('allowfullscreen', '');
        boton.replaceWith(marco);
      });
    });
  }

  /* --- Arranque ----------------------------------------------------------- */

  function arrancar() {
    // Cada pieza va aislada: si una revienta, las demas siguen y sobre todo el
    // contenido no se queda escondido por un fallo en otra parte.
    var piezas = [initStagger, initMarquesinas, initReveals, initParallax,
                  initContadores, initFaq, initComparadores, initGaleria, initVariantes,
                  initCarruseles, initStickyCompra, initVideoLazy];

    for (var i = 0; i < piezas.length; i++) {
      try {
        piezas[i]();
      } catch (e) {
        if (window.console && console.warn) console.warn('vs: fallo en ' + piezas[i].name, e);
        // Si lo que ha fallado son los reveals, hay que mostrar todo ya
        if (piezas[i] === initReveals) rendirse();
      }
    }
  }

  // Ultimo cortafuegos: cualquier error suelto no debe dejar la tienda en blanco
  window.addEventListener('error', function () {
    if (!document.querySelector('.vs-reveal.vs-visible')) rendirse();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de Shopify recarga secciones sueltas: re-inicializa lo necesario
  document.addEventListener('shopify:section:load', arrancar);
})();

/* ==========================================================================
   OCULTAR LA FILA "DESCUENTOS" DEL CARRITO DE UPCART
   ==========================================================================
   El carrito lo dibuja la app UpCart DENTRO de un shadow DOM, asi que el CSS
   de vs-styles.css NO llega hasta ahi: hay que inyectar el estilo dentro del
   propio shadow root.

   Se oculta ".upcart-savings-row", que es la clase semantica y estable que
   pone la app. NO se usa "styles_Footer__savings__" porque ese nombre lleva un
   hash y cambia en cada version de UpCart.

   Por que se oculta: la clienta ya ve el precio anterior tachado en la linea
   del producto, asi que la fila repetia la informacion. Ademas el titulo largo
   del descuento ("PACK 4 BOTES - COMPRA 2 Y LLEVATE 2 GRATIS") partia el
   importe en dos lineas y rompia la maquetacion del pie del carrito.

   OJO: el descuento SIGUE APLICANDOSE, solo deja de mostrarse esa fila.
   Alternativa limpia si algun dia se prefiere: en el panel de UpCart, el
   ajuste "savingsRowBehaviour" permite ocultarla sin tocar codigo.
   ========================================================================== */
(function () {
  var ID = 'vs-upcart-oculta-descuento';
  var CSS = '.upcart-savings-row{display:none !important;}';
  var observando = false;

  function inyectar() {
    var host = document.getElementById('upCart');
    if (!host || !host.shadowRoot) return false;
    if (!host.shadowRoot.getElementById(ID)) {
      var st = document.createElement('style');
      st.id = ID;
      st.textContent = CSS;
      host.shadowRoot.appendChild(st);
    }
    // UpCart vuelve a pintar su contenido al cambiar el carrito: si en algun
    // repintado se lleva por delante el <style>, se vuelve a poner.
    if (!observando) {
      observando = true;
      new MutationObserver(function () {
        if (!host.shadowRoot.getElementById(ID)) {
          var s2 = document.createElement('style');
          s2.id = ID;
          s2.textContent = CSS;
          host.shadowRoot.appendChild(s2);
        }
      }).observe(host.shadowRoot, { childList: true });
    }
    return true;
  }

  // El shadow root no existe hasta que la app arranca: se reintenta un rato y
  // se deja de insistir para no dejar un temporizador vivo toda la sesion.
  if (!inyectar()) {
    var intentos = 0;
    var t = setInterval(function () {
      intentos++;
      if (inyectar() || intentos > 40) clearInterval(t);
    }, 500);
  }
})();

/* ==========================================================================
   CORTE DE ENVIO ("pide antes de las X y sale hoy")
   ==========================================================================
   Urgencia honesta: no inventa stock ni pone una cuenta atras que manana
   vuelve a empezar. Dice un hecho operativo y se adapta solo.

   La hora se calcula SIEMPRE en zona de Ciudad de Mexico, no en la del
   dispositivo. Si se usara la del navegador, a una clienta en Tijuana (dos
   horas menos) le saldria una cuenta atras que no corresponde con el almacen,
   y a una que viaje al extranjero le saldria cualquier cosa.

   Fines de semana no se promete envio: el sabado y el domingo dice "sale el
   lunes". Si algun dia se despacha en sabado, quitar el 6 de FINDE.
   ========================================================================== */
(function () {
  var FINDE = [0, 6]; // 0 = domingo, 6 = sabado
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  // Devuelve {dia, hora, min} en hora de CDMX, sea cual sea el reloj del movil
  function ahoraCDMX() {
    var f = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Mexico_City',
      weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var d = {};
    f.forEach(function (p) { d[p.type] = p.value; });
    var semana = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      dia: semana[d.weekday],
      hora: parseInt(d.hour, 10) % 24,
      min: parseInt(d.minute, 10)
    };
  }

  function siguienteHabil(dia) {
    var d = dia;
    for (var i = 0; i < 7; i++) {
      d = (d + 1) % 7;
      if (FINDE.indexOf(d) === -1) return d;
    }
    return 1;
  }

  function pintar(el) {
    var corte = parseInt(el.getAttribute('data-hora'), 10);
    if (!(corte > 0)) return;
    var t = ahoraCDMX();
    var esFinde = FINDE.indexOf(t.dia) !== -1;
    var pasado = (t.hora > corte) || (t.hora === corte && t.min > 0);
    var etiqueta = (corte > 12 ? corte - 12 : corte) + ':00 ' + (corte >= 12 ? 'pm' : 'am');

    var texto;
    if (esFinde || pasado) {
      var d = siguienteHabil(t.dia);
      var cuando = (!esFinde && d === (t.dia + 1) % 7) ? 'mañana' : 'el ' + DIAS[d];
      texto = 'Sale ' + cuando + '. Pide antes de las ' + etiqueta + ' y entra en el envío del día.';
    } else {
      var faltan = (corte - t.hora) * 60 - t.min;
      var h = Math.floor(faltan / 60), m = faltan % 60;
      var queda = h > 0 ? (h + ' h ' + m + ' min') : (m + ' min');
      texto = 'Pide antes de las ' + etiqueta + ' y sale hoy mismo · quedan ' + queda;
    }
    el.textContent = texto;
    el.hidden = false;
  }

  function arrancarCorte() {
    var els = document.querySelectorAll('[data-vs-corte]');
    if (!els.length) return;
    els.forEach(pintar);
    // Se refresca cada minuto para que la cuenta atras no se quede congelada
    // si la clienta deja la pestana abierta.
    setInterval(function () { els.forEach(pintar); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarCorte);
  } else {
    arrancarCorte();
  }
  document.addEventListener('shopify:section:load', arrancarCorte);
})();
